import { RecordUtils } from "@rsm-hcd/javascript-core";
import FeatureFlag from "models/interfaces/feature-flag";
import { Record as ImmutableRecord } from "immutable";

const defaultValues: FeatureFlag =
    RecordUtils.defaultValuesFactory<FeatureFlag>({
        name: "",
        isEnabled: false,
    });

export default class FeatureFlagRecord
    extends ImmutableRecord(defaultValues)
    implements FeatureFlag
{
    constructor(params?: FeatureFlag) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }
        super(params);
    }

    public with(values: Partial<FeatureFlag>): FeatureFlagRecord {
        return this.merge(values) as FeatureFlagRecord;
    }
}
